import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { PageLoading } from '../common/Loading';

interface ProtectedRouteProps {
  children: React.ReactNode;
  adminOnly?: boolean;
  vendedorOnly?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  adminOnly = false,
  vendedorOnly = false,
}) => {
  const { isAuthenticated, usuario, isLoading } = useAuthStore();
  const location = useLocation();

  if (isLoading) {
    return <PageLoading message="Verificando autenticação..." />;
  }

  if (!isAuthenticated) {
    // Redirect to login with return URL
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (adminOnly && usuario?.tipo !== 'admin') {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="text-center">
          <span className="text-6xl mb-4 block">🔒</span>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Acesso Restrito</h2>
          <p className="text-gray-600 mb-6">
            Você não tem permissão para acessar esta página.
          </p>
          <a
            href="/"
            className="px-6 py-3 bg-green-700 hover:bg-green-800 text-white rounded-lg font-medium transition-colors inline-block"
          >
            Voltar ao Início
          </a>
        </div>
      </div>
    );
  }

  if (vendedorOnly && usuario?.tipo !== 'vendedor' && usuario?.tipo !== 'admin') {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="text-center">
          <span className="text-6xl mb-4 block">🏪</span>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Área de Vendedores</h2>
          <p className="text-gray-600 mb-6">
            Esta área é exclusiva para vendedores. Atualize seu perfil para vender.
          </p>
          <a
            href="/perfil"
            className="px-6 py-3 bg-green-700 hover:bg-green-800 text-white rounded-lg font-medium transition-colors inline-block"
          >
            Ir para Perfil
          </a>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
